import { authFetch } from '../utils/apiClient';
// Auction CRUD
export const auctionService = {
    async createAuction(input) {
        const response = await authFetch('auction-create', {
            method: 'POST',
            body: JSON.stringify(input),
        });
        return response.data || { success: false, error: response.error };
    },
    async listAuctions(params = {}) {
        const searchParams = new URLSearchParams();
        if (params.status)
            searchParams.set('status', params.status);
        if (params.type)
            searchParams.set('type', params.type);
        searchParams.set('page', String(params.page || 1));
        searchParams.set('pageSize', String(params.pageSize || 20));
        const response = await authFetch(`auction-list?${searchParams}`);
        return response.data || { success: false, data: { auctions: [], pagination: { page: 1, pageSize: 20, total: 0, totalPages: 0 } }, timestamp: '' };
    },
    async getAuctionDetail(auctionId) {
        const response = await authFetch(`auction-detail?auctionId=${auctionId}`);
        return response.data || { success: false, data: { auction: {}, summary: {} } };
    },
    async updateAuction(auctionId, updates) {
        const response = await authFetch('auction-update', {
            method: 'PATCH',
            body: JSON.stringify({ auctionId, ...updates }),
        });
        return response.data || { success: false };
    },
    async cancelAuction(auctionId) {
        const response = await authFetch('auction-cancel', {
            method: 'POST',
            body: JSON.stringify({ auctionId }),
        });
        return response.data || { success: false, error: response.error };
    },
    // Bidding
    async placeBid(auctionId, amount) {
        const response = await authFetch('auction-bid', {
            method: 'POST',
            body: JSON.stringify({ auctionId, amount }),
        });
        return response.data || { success: false, error: response.error };
    },
    async getMyBids(params = {}) {
        const searchParams = new URLSearchParams();
        if (params.status)
            searchParams.set('status', params.status);
        searchParams.set('page', String(params.page || 1));
        searchParams.set('pageSize', String(params.pageSize || 20));
        const response = await authFetch(`auction-my-bids?${searchParams}`);
        return response.data || { success: false, data: { bids: [], pagination: { page: 1, pageSize: 20, total: 0, totalPages: 0 } } };
    },
    // Summary (REST fallback for reconnection)
    async getSummary(auctionId) {
        const response = await authFetch(`auction-summary?auctionId=${auctionId}`);
        return response.data || { success: false, data: { summary: {} } };
    },
    // SignalR
    async watchAuction(auctionId, action) {
        const response = await authFetch('auction-watch', {
            method: 'POST',
            body: JSON.stringify({ auctionId, action }),
        });
        return response.data || { success: false };
    },
    async negotiateSignalR() {
        const response = await authFetch('auction-signalr-negotiate');
        return response.data;
    },
    // Supervised auction control
    async supervisedAction(payload) {
        const response = await authFetch('auction-supervised-action', {
            method: 'POST',
            body: JSON.stringify(payload),
        });
        return response.data || { success: false, error: response.error };
    },
    // Analytics
    async getAnalytics(params = {}) {
        const searchParams = new URLSearchParams();
        if (params.dateFrom)
            searchParams.set('dateFrom', params.dateFrom);
        if (params.dateTo)
            searchParams.set('dateTo', params.dateTo);
        if (params.type)
            searchParams.set('type', params.type);
        const response = await authFetch(`auction-analytics?${searchParams}`);
        return response.data || { success: false, data: {} };
    },
};
